import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import axios, {  } from 'axios';
import {  Link } from 'react-router-dom';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import moment from 'moment';
import '../../App.css';
import paginationFactory, { PaginationProvider, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";
//import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

function dateFormat(value, row, index) {
    if (value == null) return 'None';
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
class ViewInvoiceHistory extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            account: props.location.state.account,
            page: 1,
            data: [],
            totalSize: 0,
            searchTerm: '',
            sizePerPage: 20,
            selected: [],
            loading: false
        };

        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleDownloadSelected = this.handleDownloadSelected.bind(this);
        this.showButton = this.showButton.bind(this);

        this.showCSVButton = this.showCSVButton.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);

        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);


        this.tableRef = React.createRef();
    }

    componentDidMount() {
        this.handleTableChange("None", this.state);
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleDownloadSelected}>
                Download Selected
            </Button>
        }
    }

    handleClear() {
        this.setState({
            searchTerm: '',
            page: 1
        }, function () {
            this.handleTableChange("None", { page: 1, sizePerPage: 10 });
        });
    }
    handleSearch(event) {
        event.preventDefault();
        this.state.page = 1;
            this.handleTableChange("None", this.state);
    }

    handleSearchChange(event) {
        this.setState({
            searchTerm: event.target.value
        });
    }

    handleSelect = (row, isSelect) => {
        let allow = true;
        let CurrentSelected = [];
        if (isSelect) {
            CurrentSelected = [...this.state.selected, row];
        } else {
            allow = false;
            CurrentSelected = this.state.selected.filter(x => x !== row);
        }
        this.state.selected = CurrentSelected;
    }

    handleSelectAll = (isSelect, rows) => {
        let allow = true;
        let CurrentSelected = [];
        if (isSelect) {
            CurrentSelected = rows;
        } else {
            CurrentSelected = [];
        }
        this.state.selected = CurrentSelected;
    }

    //handleSelect = (row, isSelect) => {
    //    if (isSelect) {
    //        this.setState(() => ({
    //            selected: [...this.state.selected, row]
    //        }));
    //    } else {
    //        this.setState(() => ({
    //            selected: this.state.selected.filter(x => x !== row)
    //        }));
    //    }
    //}

    //handleSelectAll = (isSelect, rows) => {
    //    if (isSelect) {
    //        this.setState(() => ({
    //            selected: rows
    //        }));
    //    } else {
    //        this.setState(() => ({
    //            selected: []
    //        }));
    //    }
    //}


    handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        if (type == "pagination") {
            this.tableRef.current.selectionContext.selected = [];
            this.setState(() => ({
                selected: []
            }));
        }
        axios.get(`${Constants.apiURL}/api/Payment/invoices`, {
            params: {
                user: this.state.user.username,
                accountID: this.state.account.accountID.trim(),
                page: page,
                pageSize: sizePerPage,
                sortOrder: sortOrder,
                sortField: sortField,
                searchTerm: this.state.searchTerm.trim(),
                isHistory: true
            }
        }).then(response => {
            console.log(response);
            if (response.data) {

                //state.bdata = JSON.parse(response.data.data);
                //state.btotalSize = response.data.rowcount;
                this.setState(() => ({
                    page: page,
                    sizePerPage: sizePerPage,
                    sortField: sortField,
                    sortOrder: sortOrder,
                    data: JSON.parse(response.data.data),
                    totalSize: response.data.rowcount,
                    selected: []
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    handleDownloadSelected(event) {

        event.preventDefault();
        if (this.state.selected.length == 0) { return; }
        this.setState({ loading: true });

        let invoiceNums = this.state.selected.reduce(function (str, item) {
            return str + item.DocumentNumber + ",";
        }, '');
        axios.get(`${Constants.apiURL}/api/Payment/download`, {
            params: {
                user: this.state.user.username,
                invoiceNums: invoiceNums
            },
            responseType: "blob"
        }).then(response => {
            this.setState({ loading: false });
            ReactGA.event({
                category: 'Download',
                action: 'Closed Invoice Download',
                label: 'Invoice History - Download Invoice'
            });

            let blob = new Blob([response.data], { type: "application/zip" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }
            else {
                alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                return;
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }
    downloadCSV(event) {

        this.setState({ downloadingCSV: true });
        axios.get(`${Constants.apiURL}/api/Payment/invoicesCSV`, {
            params: {
                user: this.state.user.username,
                accountID: this.state.account.accountID,
                searchTerm: this.state.searchTerm,
                type: this.state.filterEntityType,
                isHistory: true
            },
            responseType: 'blob'
        }).then(response => {
            ReactGA.event({
                category: 'Download',
                action: 'Download Closed Invoice CSV',
                label: 'Invoice History'
            });
            this.setState({ downloadingCSV: false });
            if (response.data) {
                if (response.data == 'No files found.') return;
                let blob = new Blob([response.data], { type: 'text/csv' }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ downloadingCSV: false });
            console.log('request failed', response)
        });
    }
    showCSVButton() {
        if (this.state.downloadingCSV) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Downloading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.downloadCSV}>
                Export as CSV
            </Button>
        }
    }

    render() {
        const { data, totalSize, page, sizePerPage } = this.state;
        const columns = [
            {
                dataField: 'DocumentNumber',
                text: 'Invoice #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'PONumber',
                text: 'PO #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'DocumentDate',
                text: 'Invoice Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'LastPaymentDate',
                text: 'Last Payment Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'OriginalAmount',
                text: 'Total Invoice Amount',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BalanceDue',
                text: 'Invoice Balance',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'InvoiceStatus',
                text: 'Status',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'EntityType',
                text: 'Entity',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BuildingName',
                text: 'Building',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'OrderNumber',
                text: 'Order Number',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                },
                formatExtraData: this.state,
                formatter: (cell, row, props, p) => {
                    return <Link to={{
                        pathname: 'view_order_details',
                        state: {
                            user: p.user,
                            input: {
                                BuildingName: row.BuildingName,
                                Id: row.OrderKey,
                                OrderNumber: row.OrderNumber,
                                CreatedDate: row.CreatedDate,
                                PurchaseOrder: row.PurchaseOrder,
                                DisplayID: row.DisplayID,
                                OrderType: row.OrderType
                            }
                        }
                    }}> {cell} </Link>
                }
            }

        ];
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleSelect,
            onSelectAll: this.handleSelectAll,
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };
        const pagination = {
            custom: true,
            totalSize: totalSize,
            page: page,
            sizePerPage: sizePerPage
        };
        return (
            <div class="open_invoices">
                <SiteMenu user={this.state.user} currentPage='invoiceHistory' />
                <Form onSubmit={this.handleSearch} className="mb-3">
                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 15px 0px 15px' }} className="mobile-order-0">
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 20 }}>INVOICE HISTORY</Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 15px 0px 15px' }} className="mobile-order-1">

                        <Col md={{ span: 4, order: 0 }} xs={{ span: 12, order: 2 }} >
                            <Form.Control ref={this.filterText} value={this.state.searchTerm} type="input" size="sm" onChange={this.handleSearchChange} placeholder="Search by invoice, PO number, or building..." />
                        </Col>
                        <Col md={{ span: 'auto', order: 1 }} xs={{ span: 12, order: 3 }} style={{ paddingLeft: 0, paddingRight: 0 }} >
                            <Button size="sm" style={{ width: 'auto', backgroundColor: '#1F419B' }} type="submit" >Search</Button>
                        </Col>
                        <Col md={{ span: 'auto', order: 3 }} xs={{ span: 12, order: 4 }} >
                            <Button size="sm" style={{ width: 'auto', marginLeft: 0 }} variant="secondary" onClick={this.handleClear}>Clear</Button>
                        </Col>
                        <Col style={{flexGrow:1}} md={{ span: 'auto', order: 4 }} xs={{ span: 12, order: 1 }} className="mobile-none"/>
                        <Col md={{ span: 'auto', order: 5 }} xs={{ span: 12, order: 0 }}>
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.account.accountID} | {this.state.account.accountName}</Form.Label>
                        </Col>
                        <Col md={{ span: 'auto', order: 5 }} xs={{ span: 12, order: 1 }} style={{ paddingLeft: 0 }}>
                            <Button as={Link} to={{
                                pathname: "/open_invoices",
                                state: {
                                    user: this.state.user,
                                    account: this.state.account
                                }
                            }}  style={{ backgroundColor: '#00973A' }} size="sm">
                                View Open Invoices
                            </Button>
                        </Col>
                    </Form.Group>
                </Form>
                <PaginationProvider pagination={paginationFactory(pagination)}>
                    {({
                        paginationProps,
                        paginationTableProps
                    }) => (
                        <div>
                            <BootstrapTable
                                remote
                                keyField="InvoiceKey"
                                wrapperClasses="table-responsive"
                                data={data}
                                columns={columns}
                                onTableChange={this.handleTableChange}
                                selectRow={selectRow}
                                noDataIndication={() => <Form.Label>No invoice history.</Form.Label>}
                                hover
                                striped
                                ref={this.tableRef}
                                {...paginationTableProps}
                            />
                            <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 0px 10px', marginRight: 0 }}>

                                <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 10 }}>
                                    {this.showButton()}
                                </Col>
                                <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                                    {this.showCSVButton()}
                                </Col>
                                <Col width='100%' />
                                <Col md="auto" sm="auto" xs="auto"
                                    style={{ paddingRight: '10px' }} >
                                    <PaginationListStandalone
                                        {...paginationProps}
                                    />
                                </Col>
                            </Form.Group>
                        </div>
                    )
                    }
                </PaginationProvider>
            </div>
        );
    }
}

export default ViewInvoiceHistory;